import React from 'react'
import { Redirect } from 'react-router-dom'
import store from '../stores/configureStore'
import logger from 'loglevel'

export default function onEnter(props, replace) {
  const state = store.getState()
  const rootURL = state.server.rootURL
  if (!state.crossBorder.toCountryCode) {
    logger.warn('A valid recipient country required to continue.')
    return <Redirect to={`${rootURL}/homepage`} />
  }
}
